export default __webpack_public_path__ + "static/media/article_business_standerd.a376b644.png";